import { render } from "./ViewAuctionHouses.vue?vue&type=template&id=86a2ef5a&scoped=true"
import script from "./ViewAuctionHouses.vue?vue&type=script&lang=js"
export * from "./ViewAuctionHouses.vue?vue&type=script&lang=js"

import "./ViewAuctionHouses.vue?vue&type=style&index=0&id=86a2ef5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a2ef5a"]])

export default __exports__